import React from "react";
import { FAQS } from "../mock";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { HelpCircle, MessageSquare } from "lucide-react";

export default function FAQ() {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-700">FAQ</div>
          <h2 className="display section-underline mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 uppercase">
            Questions, Answered
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            Everything procurement and design teams ask before engaging NEWCON. Still curious? Talk to a specialist.
          </p>
          <a href="#contact" className="mt-7 inline-flex items-center gap-2 px-5 py-3 bg-slate-900 text-white font-semibold rounded-md hover:bg-yellow-700 transition-colors">
            <MessageSquare className="w-4 h-4" /> Ask Our Team
          </a>
        </div>

        <div className="lg:col-span-3">
          <Accordion type="single" collapsible defaultValue="item-0" className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white border border-slate-200 rounded-lg px-5 data-[state=open]:border-yellow-600 data-[state=open]:shadow-md"
              >
                <AccordionTrigger className="text-left font-semibold text-slate-900 hover:no-underline py-5">
                  <span className="flex items-start gap-3">
                    <span className="shrink-0 w-7 h-7 rounded-full bg-yellow-100 text-yellow-800 grid place-items-center text-xs font-bold">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span>{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pl-10 pr-2 pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
